<div class="analysis-nav" [attr.data-analysis-type]="analysisType">
  <h6 class="nav-title">{{ config.title }}</h6>
  <div class="nav-context">
    <div class="company-info">
      <small class="text-muted">{{ getCompanyName() }}</small>
    </div>
    <div class="project-info">
      <small class="project-name">{{ getProjectName() }}</small>
    </div>
  </div>
  <nav class="nav-menu">
    <ul class="nav-list">
      @for (item of config.navItems; track item) {
      <li class="nav-item" [class.active]="item.isActive">
        <a href="#" class="nav-link" (click)="$event.preventDefault(); navigateTo(item)" [class.active]="item.isActive">
          {{ item.label }}
        </a>
      </li>
      }
    </ul>
    <div class="nav-footer">
      <a href="#" class="nav-home-link" (click)="$event.preventDefault(); navigateToHome()"> ← Back to Home </a>
    </div>
  </nav>
</div>
